module.exports = __webpack_public_path__ + "img/stripe-integration.6b28b016.png";